/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './SubContractorsComponent.module.scss';
import metadata from './SubContractorsComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function SubContractorsComponent(props) {

    const {
        data: SubcontractorsVM,
        updateWizardData,
        submissionVM,
        SubcontractorsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addSubcontractors = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            SubcontractorsVM.value = SubcontractorsVM.value || []

            const { _xCenter, _dtoName } = SubcontractorsVM;

            const SubcontractorsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SubcontractorsObjVM.value.isValidationReq = true

            SubcontractorsVM.pushElement(
                SubcontractorsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, SubcontractorsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            SubcontractorsVM.value.splice(index, 1);
            _.set(submissionVM.value, SubcontractorsPath, SubcontractorsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, SubcontractorsPath, SubcontractorsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'des2') {
                const value = item.des2 ? item.des2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        disabled={item.worSub1 === undefined || item.worSub1 !== '25Oth'}
                    />
                );
            }

            if (path === 'worSub1') {
                const value = (item && item.worSub1) ? item.worSub1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = SubcontractorsVM.length > 0 && SubcontractorsVM.children[index].worSub1
                    // eslint-disable-next-line security/detect-object-injection
                    ? SubcontractorsVM.children[index].worSub1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.worSub1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }


        }, [SubcontractorsVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`SubcontractorsTable`]: {
            data: SubcontractorsVM.value,
        }

    }), [SubcontractorsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addSubcontractors,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            SubcontractorsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [SubcontractorsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={SubcontractorsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubContractorsComponent.propTypes = wizardProps;
export default withRouter(SubContractorsComponent);
